import styled from 'styled-components';

export const Container = styled.div`
  span {
    color: #4c4c4c;

    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 400;
  }
`;
